// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__Dp8Mj","inner":"Layout_inner__LBEQY","steps":"Layout_steps__2Ah9T","active":"Layout_active__2Wxoh","content":"Layout_content__ODjJp"};